module.exports = __webpack_public_path__ + "static/img/jsmagic1pict5.41c86b9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jsmagic1pict5.jpg
// module id = KL69
// module chunks = 0